import { AppInsights } from 'applicationinsights-js';

import Analytics from './Analytics';

const AIAnalytics: Analytics = {
    configure(key?: string) {
        if (!key || !AppInsights.downloadAndSetup) {
            return;
        }
        AppInsights.downloadAndSetup({ instrumentationKey: key });
    },

    trackPageView() {
        AppInsights.trackPageView();
    },
};

export default AIAnalytics;
